import React from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as SettingsActionCreators from '../../../actions/settings';

class EmailUpdateDialog extends React.Component {
  /**
   * State
   * @type {Object}
   */
  state = {
    emailAddress: '',
  }


  /**
   * Component Will Mount
   * @return {undefined}
   */
  componentWillMount = () => {
    this.setState({
      emailAddress: this.props.data.emailAddress,
    });
  }


  /**
   * Handle change
   * @param  {Object} e
   * @return {undefined}
   */
  handleChange = (e) => {
    this.setState({
      emailAddress: e.target.value,
    });
  }


  /**
   * Handle form submit
   * @return {Object}
   */
  handleFormSubmit = (e) => {
    e.preventDefault();

    const { emailAddress } = this.state;

    if (!emailAddress) {
      return;
    }

    this.props.dispatch(SettingsActionCreators.updateEmailAddress(emailAddress));
  }


  /**
   * Render
   * @return {JSX}
   */
  render() {
    const { message, isUpdatingEmail } = this.props;

    return (
      <div>
        <h3 className="heading heading--2" style={{ color: '#000' }}>Update email address</h3>
        <form onSubmit={this.handleFormSubmit}>
          <p style={{ paddingTop: 12 }}>
            <label htmlFor="emailAddress">Email</label>
            <input id="emailAddress" className="form__control" type="email" name="emailAddress" onChange={this.handleChange} value={this.state.emailAddress} />
          </p>
          { message ? <p dangerouslySetInnerHTML={{ __html: message }} /> : null }
          <div className="dialog__actions" style={{ marginTop: 24 }}>
            <button className="button button--primary" onClick={this.props.closeDialog}>Cancel</button>
            <button className="button button--primary" disabled={!this.state.emailAddress}>{ isUpdatingEmail ? 'Saving...' : 'Update Email' }</button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    isUpdatingEmail: state.settings.isUpdatingEmail,
    message: state.settings.emailMessage,
    data: state.settings.data,
  }
);

export default withRouter(connect(mapStateToProps)(EmailUpdateDialog));
